import {Controller} from "stimulus"

export default class extends Controller {

    connect() {
        this.loadTableData();
    }

    loadTableData() {
        const dataSource = this.data.get("data-source");
        if (!dataSource) { return; }

        const chartArea = document.querySelector(".report-chart-area");
        if (!chartArea) { return; }

        let tableParam = "?type=table";
        if (dataSource.includes('?')) {
            tableParam = "&type=table";
        }

        fetch(dataSource + tableParam)
            .then(response => {
                if (!response.ok) {
                    return response.json().then(data => {
                        throw new Error(data.error || "Failed to load report data");
                    });
                }
                return response.json();
            })
            .then(parsedData => {
                if (parsedData.length > 0) {
                    const numColumns = Object.keys(parsedData[0]).length;
                    const tableClasses = numColumns > 8 ? 'table striped-table text-sm' : 'table striped-table';
                    chartArea.innerHTML = json2table(parsedData, tableClasses);
                }
            })
            .catch(error => {
                chartArea.innerHTML = '<div class="p-4 text-red-600 bg-red-50 rounded-md">' +
                    '<p class="font-medium">Unable to load report</p>' +
                    '<p class="text-sm mt-1">' + error.message + '</p>' +
                    '</div>';
            });
    }

}

// from https://travishorn.com/building-json2table-turn-json-into-an-html-table-a57cf642b84a
function json2table(json, classes) {
    var cols = Object.keys(json[0]);

    var headerRow = '';
    var bodyRows = '';

    classes = classes || 'table striped-table';

    function capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    cols.map(function (col) {
        headerRow += '<th>' + capitalizeFirstLetter(col) + '</th>';
    });

    json.map(function (row) {
        bodyRows += '<tr>';

        cols.map(function (colName) {
            bodyRows += '<td>' + row[colName] + '</td>';
        })

        bodyRows += '</tr>';
    });

    return '<table class="' +
        classes +
        '"><thead><tr>' +
        headerRow +
        '</tr></thead><tbody>' +
        bodyRows +
        '</tbody></table>';
}
